<div #colorPickerToggle class="selectable color-picker-toggle" [style.background]="color" (click)="showColorPicker = true;"></div>
<div class="color-picker" #colorPickerContainer>
    <mark *ngIf="showColorPicker" title="Close Color Picker" class="icon-ui-close label label-blue" (click)="showColorPicker = false;"></mark>
    <color-sketch *ngIf="showColorPicker" [color]="color" [width]="120" (onChange)="pickerColorChanged($event)"></color-sketch>
</div>
